import { PRECAMPAIGN_PAGE_KEY } from '../constants';

export default {
  pt: {
    [PRECAMPAIGN_PAGE_KEY]: {
      HERO_TITLE: 'Nombre promo en Crehana',
      HERO_SUBTITLE:
        'Lorem ipsum dolor sit amet. Ex distinctio exercitationem ea aliquid ducimus non fugit culpa ',
      HERO_DATE: '24 y 25 / Noviembre / 2021',
      REGISTER_FORM_TITLE:
        'Entérate de las promociones del BlackFriday antes que todos',
      AUTH_WITH_EMAIL: 'o Regístrate con email',
      AUTH_WITH_SOCIALNET: 'o regístrate por redes sociales',
      AGREE_TYC: 'Al registrarte aceptas nuestros ',
      LINK_TYC: 'Términos y Políticas de Privacidad.',
      START_FREE_TRIAL: 'Empieza tu prueba gratuita',

      PRODUCTS_PAYG_TITLE: 'Más de 800 cursos en 22 categorías',
      PRODUCTS_PAYG_SUBTITLE:
        'Aprende con expertos de Marketing, Negocios, Diseño, Video, Fotografía y más para actualizarte en los temas de mayor tendencia.',
      PRODUCTS_PACKS_TITLE: 'Arma tu pack de cursos',
      PRODUCTS_PACKS_SUBTITLE:
        'Combínalos como prefieras y arma el pack de cursos ideal para crecer en tu carrera profesional, emprendimiento o hobbies.',
      PRODUCTS_PREMIUM_TITLE: 'Planes Premium',
      PRODUCTS_PREMIUM_SUBTITLE:
        'Obtén acceso total a todos nuestros cursos, asesorías y atención personalizada por 1 año. ¡Elige el plan perfecto para ti o para compartir!',

      SEE_MORE: 'Ver más',

      PRODUCTS_MICRODEGREE_TITLE: 'Aprende con las mejores universidades',
      PRODUCTS_MICRODEGREE_SUBTITLE:
        'El MicroDegree es un programa online de 4 meses, co-certificado con universidades destacadas en Latinoamérica, sobre temas especializados de alta demanda en el mercado.',

      MICRODEGREE_PRODUCT_MANAGEMENT: 'MicroDegree en Product Management',
      MICRODEGREE_MARKETING: 'MicroDegree en Marketing Digital',
      MICRODEGREE_UXUI: 'MicroDegree en Data Analytics',
      MICRODEGREE_DATA: 'MicroDegree en UX/UI',

      FAQ_TITLE: 'Preguntas Frecuentes',

      PROMO_ENDS: 'Esta promoción termina en:',
    },
  },
};
